import Validator from "validatorjs";
import * as validators from "./validators";
import { messages } from "./messages";
/**
 * Sets the default messages for the validator.
 */
Validator.setMessages(Validator.getDefaultLang(), messages);
/**
 * Registers all the custom validators.
 */
Object.keys(validators).forEach(key => {
    const validator = validators[key];
    if (validator.isImplicit) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        Validator.registerImplicit(validator.name, validator.validate, validator.errorMessage);
    }
    else {
        Validator.register(validator.name, validator.validate, validator.errorMessage);
    }
});
